import React, { Component } from "react";
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Button,
  TextField,
  IconButton,
  Icon,
} from "@material-ui/core";
// import { theme } from '../../Theme';
import "../preguia/Preguia.css";
import Http from "../../../Http";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
import PreguiaProductos from '../preguia/PreguiaProductos';

export default class Confirmacion extends Component {
  state = {
    id_carga_tipo: 1,
    paquetes: [],
    // id_origen_destino: '',
    pg_observaciones: "",
    pg_peso: "",
    pg_ser_recoleccion: false,
    pg_ser_entrega: false,
    pg_ser_seguro: false,
    origen_id_sucursal: "",
    destino_id_sucursal: "",
    pg_valor_declarado: "",
    pg_cliente_es: "",
    pg_recol_fecha: new Date(),
    carga_tipos: [],
    sucursales: [],
    embalajes: [],
    id_grupo_embalaje: "",
    embalaje_grupos: [],
    origenes_destinos: [],
    cliente: {},
    productos: [],
    showDetailProduct: false,
  };

  componentDidMount() {
    this.loadPreguia();
    this.getFormData(false, true);
  }

  getFormData = async (eg = null, initial) => {
    let Res = await Http.get(`preguia/detalle/form?${eg ? `&eg=${eg}` : ""}${initial ? `&initial=${initial}` : ""}`);
    let { embalaje_grupos, embalajes, sucursales } = this.state;
    if (!Res.error) {
      if (Res.data.embalaje_grupos) {
        embalaje_grupos = Res.data.embalaje_grupos
      }
      if (Res.data.embalajes) {
        embalajes = Res.data.embalajes
      }
      if (Res.data.sucursales) {
        sucursales = Res.data.sucursales
      }
      this.setState({
        embalaje_grupos,
        embalajes,
        sucursales,
      });
    }
  };

  loadPreguia = async () => {
    let Res = await Http.get(`preguia/info/${this.props.preguia.id}`);
    if (!Res.error) {
      this.getFormData(Res.data.id_grupo_embalaje);
      this.setState({
        id_carga_tipo: Res.data.id_carga_tipo,
        id_grupo_embalaje: Res.data.id_grupo_embalaje,
        // id_origen_destino: Res.data.id_origen_destino,
        origen_id_sucursal: Res.data.origen_id_sucursal,
        destino_id_sucursal: Res.data.destino_id_sucursal,
        paquetes: Res.data.paquetes,
        productos: Res.data.productos,
        pg_observaciones: Res.data.pg_observaciones,
        pg_peso: Res.data.pg_peso,
        pg_ser_recoleccion: Res.data.pg_ser_recoleccion,
        pg_ser_entrega: Res.data.pg_ser_entrega,
        pg_ser_seguro: Res.data.pg_ser_seguro,
        pg_valor_declarado: Res.data.pg_valor_declarado,
        pg_cliente_es: Res.data.pg_cliente_es,
        cliente: Res.data.cliente,
        pg_recol_fecha: Res.data.pg_recol_fecha
          ? Res.data.pg_recol_fecha
          : new Date(),
        showDetailProduct: true,
      });
    }
  };

  agregarPaquete = () => {
    let paquetes = this.state.paquetes;
    paquetes.push({
      id_sucursal: 2,
      pq_cantidad: "",
      id_embalaje: 1,
      pq_descripcion: "",
    });
    this.setState({ paquetes });
  };

  paqueteChange = (i, prop, value) => {
    let paquetes = this.state.paquetes;
    paquetes[i][prop] = value;
    this.setState({ paquetes });
  };

  paqueteDelete = (idx) => {
    let paquetes = this.state.paquetes.filter((p, i) => i !== idx);
    // console.log(paquetes)
    this.setState({ paquetes });
  };

  onProductosChange = (productos) => {
    this.setState({ productos });
  }

  render() {
    const {
      paquetes,
      cliente,
      pg_cliente_es,
      sucursales,
      embalaje_grupos,
      embalajes,
      origen_id_sucursal,
      pg_recol_fecha,
      id_grupo_embalaje,
      showDetailProduct = true,
      productos
    } = this.state;
    const { accion } = this.props;
    

    return (
      <div>
        <div>
          <div className="row">
            <div className="col-12 col-sm-6">
              <FormControl disabled variant="outlined" className="form-field">
                <InputLabel>Origen</InputLabel>
                <Select
                  value={sucursales.length > 0 ? origen_id_sucursal : ""}
                  onChange={(e) => {
                    this.setState({ origen_id_sucursal: e.target.value });
                  }}
                >
                  {sucursales.map((od, i) => (
                    <MenuItem value={od.id} key={i}>
                      {od.sucursal}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="col-12 col-sm-6">
              <FormControl disabled variant="outlined" className="form-field">
                <InputLabel>Tipo de carga</InputLabel>
                <Select
                  value={embalaje_grupos.length > 0 ? id_grupo_embalaje : ""}
                  onChange={(e) => {
                    this.setState({ id_grupo_embalaje: e.target.value });
                    this.getFormData(e.target.value);
                  }}
                >
                  {embalaje_grupos.map((carga, i) => (
                    <MenuItem value={carga.id} key={i}>
                      {carga.grupo}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="col-12 col-sm-12">
              <FormControl disabled variant="outlined" className="form-field">
                <InputLabel>El cliente es</InputLabel>
                <Select
                  value={pg_cliente_es}
                  onChange={(e) => {
                    this.setState({ pg_cliente_es: e.target.value });
                  }}
                >
                  {[
                    { Value: 1, Label: "Remitente" },
                    { Value: 2, Label: "Destinatario" },
                  ].map((od, i) => (
                    <MenuItem value={od.Value} key={i}>
                      {od.Label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="col-12 col-sm-2">
              <TextField
                disabled
                fullWidth
                type="number"
                label="Clave"
                value={cliente.cliente ? cliente.cliente : ""}
                variant="outlined"
                onChange={(e) => {
                  this.setState({
                    cliente: { ...cliente, cliente: e.target.value },
                  });
                }}
              />
            </div>
            <div className="col-12 col-sm-4">
              <TextField
                disabled
                fullWidth
                label=""
                value={cliente.cliente_rsocial ? cliente.cliente_rsocial : ""}
                variant="outlined"
                onChange={(e) => {
                  this.setState({
                    cliente: { ...cliente, cliente_rsocial: e.target.value },
                  });
                }}
              />
            </div>
            <div className="col-12 col-sm-3">
              <TextField
                disabled
                fullWidth
                label="R.F.C."
                value={cliente.cliente_rfc ? cliente.cliente_rfc : ""}
                variant="outlined"
                onChange={(e) => {
                  this.setState({
                    cliente: { ...cliente, cliente_rfc: e.target.value },
                  });
                }}
              />
            </div>
            <div className="col-12 col-sm-3">
              <TextField
                disabled
                fullWidth
                label="Teléfono"
                value={cliente.cliente_telefono ? cliente.cliente_telefono : ""}
                variant="outlined"
                onChange={(e) => {
                  this.setState({
                    cliente: { ...cliente, cliente_telefono: e.target.value },
                  });
                }}
              />
            </div>
            <div className="col-12 col-sm-12">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <FormControl disabled className="form-field">
                  <KeyboardDateTimePicker
                    disabled
                    inputVariant="outlined"
                    variant="inline"
                    ampm={false}
                    value={pg_recol_fecha}
                    format="dd/MM/yyyy HH:mm"
                    disablePast
                    onChange={(e) => {
                      this.setState({ pg_recol_fecha: e });
                    }}
                  />
                </FormControl>
              </MuiPickersUtilsProvider>
            </div>
          </div>
        </div>

        <div style={{ textAlign: "right", paddingTop: 10, paddingBottom: 10 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.agregarPaquete}
          >
            Agregar paquete
          </Button>
        </div>
        <div className="preguia-detalles-paquetes" hidden={paquetes.length < 1}>
          {paquetes.map((paquete, i) => (
            <div className="row paq in" key={i}>
              <div className="col-12 col-sm-2">
                <FormControl variant="outlined" className="form-field">
                  <InputLabel>Destino</InputLabel>
                  <Select
                    value={sucursales.length > 0 ? paquete.id_sucursal : ""}
                    onChange={(e) => {
                      this.paqueteChange(i, "id_sucursal", e.target.value);
                    }}
                  >
                    {sucursales.map((sucursal, i) => (
                      <MenuItem value={sucursal.id} key={i}>
                        {sucursal.sucursal}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-12 col-sm-2">
                <TextField
                  type="number"
                  label="Cantidad"
                  value={paquete.pq_cantidad}
                  variant="outlined"
                  onChange={(e) => {
                    this.paqueteChange(i, "pq_cantidad", e.target.value);
                  }}
                />
              </div>
              <div className="col-12 col-sm-3">
                <FormControl variant="outlined" className="form-field">
                  <InputLabel>Embalaje</InputLabel>
                  <Select
                    value={embalajes.length ? paquete.id_embalaje : ""}
                    onChange={(e) => {
                      this.paqueteChange(i, "id_embalaje", e.target.value);
                    }}
                  >
                    {embalajes.map((embalaje, i) => (
                      <MenuItem value={embalaje.id} key={i}>
                        {embalaje.embalaje}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-12 col-sm-4">
                <TextField
                  label="Descripción"
                  multiline
                  fullWidth
                  minRows="1"
                  value={paquete.pq_descripcion}
                  onChange={(e) => {
                    this.paqueteChange(i, "pq_descripcion", e.target.value);
                  }}
                  variant="outlined"
                />
              </div>
              <div className="col-12 col-sm-1 preguia-detalles-delete">
                <IconButton
                  onClick={() => {
                    this.paqueteDelete(i);
                  }}
                >
                  <Icon>remove_circle</Icon>
                </IconButton>
              </div>
            </div>
          ))}
        </div>

        {
          showDetailProduct && 
          <div className='preguia-detalles-paquetes'>
            <PreguiaProductos
              idpreguia={this.props.preguia.id}
              sucursales={sucursales} 
              embalajes={embalajes} 
              paquetes={paquetes}
              productos={productos}
              onProductosChange={this.onProductosChange}
            />
        </div>
        }

        <div style={{ textAlign: "center" }}>
          <Button
            style={{ margin: "0px 5px" }}
            variant="contained"
            onClick={() => {
              this.props.onClose();
            }}
          >
            Cerrar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              this.props.onConfirmar(this.state);
            }}
          >
            {
              accion !== 'detalles' ?
              'Confirmar recolección'
              : 'Guardar'
            }
          </Button>
        </div>
      </div>
    );
  }
}
